import * as React from 'react'
import { SafetySection } from '../us/safety/SafetySection'
import { FoodSafetySection } from '../us/safety/FoodSafetySection'
import { SafeDrivingSection } from '../us/safety/SafeDrivingSection'
import { SexualHarassmentSection as UsSexualHarassmentSection } from '../us/safety/SexualHarassmentSection'
import { SubmitSection } from '../us/safety/SubmitSection'

import { YourSafetyMatters } from '../au/bike-safety/your-safety-matters'
import { SafetyTipsAndRoadRules } from '../au/bike-safety/safety-tips-and-road-rules'
import { EBikes } from '../au/bike-safety/e-bikes'
import { ZeroTolerancePolicy } from '../au/shared/ZeroTolerancePolicy'
import { SafetyCourseCompletion } from '../au/shared/SafetyCourseCompletion'
import { CountryCode } from '@doordash/lib-i18n'

import { SlideProps, SlideDeck } from './types'
import { CourseMap } from './constants'
import { IntroductionSection } from '../au/shared/IntroductionSection'
import { MotorcycleVehicleSafetySection } from '../au/motorcycle-safety/MotorcycleVehicleSafetySection'
import { CarVehicleSafetySection } from '../au/car-safety/CarVehicleSafetySection'
import { ImpairedDrivingSection } from '../au/shared/ImpairedDrivingSection'
import { SexualHarassmentSection as AuSexualHarassmentSection } from '../au/shared/SexualHarassmentSection'
import { MotorcycleDasherSafetySection } from '../au/motorcycle-safety/MotorcycleDasherSafetySection'

import { MotorcycleSafetyIntroductionImage } from '../images/MotorcycleSafetyIntroductionImage'
import { CarSafetyIntroductionImage } from '../images/CarSafetyIntroductionImage'
import { CarDasherSafetySection } from '../au/car-safety/CarDasherSafetySection'
import { MotorcycleSafetyImpairedDrivingImage } from '../images/MotorcycleSafetyImpairedDrivingImage'
import { CarSafetyImpairedDrivingImage } from '../images/CarSafetyImpairedDrivingImage'

export function getSlideDeck(
  country: CountryCode,
  slideProps: SlideProps
): JSX.Element[] {
  const { courseId, buttonState, onSubmit, onAnimationEnd } = slideProps

  const slideDeck: SlideDeck = {
    AU: {
      [CourseMap.BikeSafety]: [
        <YourSafetyMatters />,
        <SafetyTipsAndRoadRules />,
        <EBikes />,
        <ZeroTolerancePolicy />,
        <SafetyCourseCompletion
          buttonState={buttonState}
          onClick={onSubmit}
          onAnimationEnd={onAnimationEnd}
        />,
      ],
      [CourseMap.CarSafety]: [
        <IntroductionSection image={<CarSafetyIntroductionImage />} />,
        <CarVehicleSafetySection />,
        <ImpairedDrivingSection image={<CarSafetyImpairedDrivingImage />} />,
        <AuSexualHarassmentSection />,
        <CarDasherSafetySection />,
        <ZeroTolerancePolicy />,
        <SafetyCourseCompletion
          buttonState={buttonState}
          onClick={onSubmit}
          onAnimationEnd={onAnimationEnd}
        />,
      ],
      [CourseMap.MotorcycleSafety]: [
        <IntroductionSection image={<MotorcycleSafetyIntroductionImage />} />,
        <MotorcycleVehicleSafetySection />,
        <ImpairedDrivingSection
          image={<MotorcycleSafetyImpairedDrivingImage />}
        />,
        <AuSexualHarassmentSection />,
        <MotorcycleDasherSafetySection />,
        <ZeroTolerancePolicy />,
        <SafetyCourseCompletion
          buttonState={buttonState}
          onClick={onSubmit}
          onAnimationEnd={onAnimationEnd}
        />,
      ],
    },
    US: {
      [CourseMap.Prop22]: [
        <SafetySection />,
        <FoodSafetySection />,
        <SafeDrivingSection />,
        <UsSexualHarassmentSection />,
        <SubmitSection
          onClick={onSubmit}
          onAnimationEnd={onAnimationEnd}
          buttonState={buttonState}
        />,
      ],
    },
  }

  const slide = slideDeck[country]

  if (!slide) return null

  return slide[courseId]
}
